import { useNavigate } from 'react-router-dom'

const serverNavigate = (path: string) => {
  window.location.href = path
}

function useIsomorphicNavigate() {
  try {
    return useNavigate()
  } catch {
    return serverNavigate
  }
}

export default useIsomorphicNavigate
